document.addEventListener("turbolinks:load", function() {
  const searchInput = document.getElementById('search-input');
  const resultsContainer = document.getElementById('search-results');

  let timeout = null;
  let latestQuery = "";
  let activeController = null;

  if (searchInput) {
    const handleInput = function() {
      const query = searchInput.value.trim();
      latestQuery = query;

      clearTimeout(timeout);

      if (query.length >= 3) {
        timeout = setTimeout(() => {
          if (activeController) {
            activeController.abort();
          }
          activeController = new AbortController();

          fetch(`/v2/current_elections/search_orders?query=${encodeURIComponent(query)}`, {
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            signal: activeController.signal
          })
          .then(response => {
            if (!response.ok) { throw new Error('Network response was not ok'); }
            return response.json();
          })
          .then(data => {
            if (query === latestQuery) {
              displaySearchResults(data, resultsContainer);
            }
          })
          .catch(error => {
            if (error.name === 'AbortError') {
              return;
            }
            resultsContainer.innerHTML = '<div class="p-4 bg-white shadow rounded">Error fetching results</div>';
          })
          .finally(() => {
            activeController = null;
          });
        }, 300);
      } else {
        if (activeController) {
          activeController.abort();
          activeController = null;
        }
        resultsContainer.innerHTML = '';
      }
    };

    searchInput.addEventListener('input', handleInput);
    searchInput.addEventListener('change', handleInput);
  }

  function displaySearchResults(data, container) {
    container.innerHTML = '';

    if (data.length === 0) {
      container.innerHTML = '<div class="p-4 bg-white shadow rounded text-gray-500 text-center">No results found</div>';
      return;
    }

    data.forEach(order => {
      const orderElement = document.createElement('a');
      orderElement.href = `/orders/${order.id}`;
      orderElement.classList.add('block', 'p-4', 'bg-white', 'shadow', 'rounded-lg', 'mb-2', 'hover:shadow-lg', 'transition', 'border', 'border-gray-200', 'hover:border-indigo-400');

      const badges = [];

      if (order.electronic_voting) {
        badges.push('<span class="px-2 py-1 text-xs leading-5 font-semibold rounded-full bg-indigo-100 text-indigo-800">Electronic Voting</span>');
      }

      if (order.in_person) {
        badges.push('<span class="px-2 py-1 text-xs leading-5 font-semibold rounded-full bg-purple-100 text-purple-800">In Person</span>');
      }

      if (order.election_value) {
        badges.push(`<span class="px-2 py-1 text-xs leading-5 font-semibold rounded-full bg-blue-100 text-blue-800">${order.election_value}</span>`);
      }

      orderElement.innerHTML = `
        <div class="flex flex-col">
          <div class="flex justify-between items-start mb-2">
            <div class="flex-1">
              <div class="font-bold text-lg text-gray-900">${order.hoa_name}</div>
              <div class="text-gray-700 text-sm mt-1">${order.full_name || 'N/A'}</div>
            </div>
            <div class="ml-4">
              <span class="text-sm text-gray-500">Order #${order.id}</span>
            </div>
          </div>
          <div class="flex flex-wrap gap-2 mt-2">
            ${badges.join('')}
          </div>
        </div>
      `;

      container.appendChild(orderElement);
    });
  }
});
